(function () {
  'use strict';

  function withImageWidth(url, width) {
    if (!url) return url;
    var base = String(url).replace(/([?&])width=\d+/g, '$1');
    base = base.replace(/\?&/g, '?').replace(/[?&]$/g, '');
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'width=' + width;
  }

  function buildSrcset(url, widths) {
    return widths
      .map(function (w) {
        return withImageWidth(url, w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function setGalleryMainImage(main, src, alt) {
    if (!main || !src) return;
    main.src = withImageWidth(src, 800);
    main.srcset = buildSrcset(src, [400, 600, 800, 1200, 1600]);
    main.sizes = '(max-width: 820px) min(100vw - 40px, 560px), 560px';
    main.alt = alt || '';
  }

  function getGalleryParts(root) {
    var main = root.querySelector('[data-tq-gallery-main]');
    var thumbs = root.querySelectorAll('[data-tq-gallery-index]');
    return { main: main, thumbs: thumbs };
  }

  function activateGalleryThumb(root, btn) {
    var parts = getGalleryParts(root);
    var main = parts.main;
    var thumbs = parts.thumbs;
    if (!main || !thumbs.length || !btn) return;
    var src = btn.getAttribute('data-tq-gallery-src');
    var alt = btn.getAttribute('data-tq-gallery-alt') || '';
    if (!src) return;
    setGalleryMainImage(main, src, alt);
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t === btn);
    });
    /* First 4 images are transparent product PNGs — show them at natural
       height (drop height:100%); all other images keep the fixed height. */
    var idx = Array.prototype.indexOf.call(thumbs, btn);
    main.classList.toggle('is-natural-height', idx > -1 && idx < 4);
  }

  function activateGalleryThumbByIndex(root, index) {
    var thumbs = getGalleryParts(root).thumbs;
    if (!thumbs.length) return;
    var i = parseInt(String(index), 10);
    if (i < 0 || i >= thumbs.length) return;
    activateGalleryThumb(root, thumbs[i]);
  }

  function stepGallery(root, dir) {
    var thumbs = getGalleryParts(root).thumbs;
    if (!thumbs.length) return;
    var current = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) {
        current = i;
        break;
      }
    }
    var nextIndex = (current + dir + thumbs.length) % thumbs.length;
    activateGalleryThumb(root, thumbs[nextIndex]);
    var activeThumb = thumbs[nextIndex];
    if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function initGallery(root) {
    var parts = getGalleryParts(root);
    var main = parts.main;
    var thumbs = parts.thumbs;
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateGalleryThumb(root, btn);
      });
    });

    var prev = root.querySelector('[data-tq-gallery-prev]');
    var next = root.querySelector('[data-tq-gallery-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        stepGallery(root, -1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        stepGallery(root, 1);
      });
    }

    /* Set the initial natural-height state based on the active thumb on load. */
    var activeBtn = null;
    thumbs.forEach(function (t) {
      if (t.classList.contains('is-active')) activeBtn = t;
    });
    if (!activeBtn) activeBtn = thumbs[0];
    var activeIdx = Array.prototype.indexOf.call(thumbs, activeBtn);
    main.classList.toggle('is-natural-height', activeIdx > -1 && activeIdx < 4);
  }

  /* Split "$69.99" into dollars + smaller cents for plan price cards.
     Whole-dollar prices stay plain; decimals can be added later per flavor. */
  function formatPlanPriceHtml(priceStr) {
    var raw = String(priceStr == null ? '' : priceStr).trim();
    if (!raw) return '';
    var match = raw.match(/^([^0-9]*)(\d+)(?:\.(\d{1,2}))?(.*)$/);
    if (!match) return raw;
    var prefix = match[1];
    var dollars = match[2];
    var cents = match[3];
    var suffix = match[4] || '';
    if (cents == null || cents === '') {
      return prefix + dollars + suffix;
    }
    if (cents.length === 1) cents = cents + '0';
    return (
      prefix +
      dollars +
      '<span class="tq-plan__cents">.' +
      cents +
      '</span>' +
      suffix
    );
  }

  function applyFlavorPricing(root, pill) {
    var map = [
      { attr: 'data-tq-price-monthly', sel: '[data-tq-price-for="monthly"]', planPrice: true },
      { attr: 'data-tq-strike-monthly', sel: '[data-tq-strike-for="monthly"]' },
      { attr: 'data-tq-save-monthly', sel: '[data-tq-save-for="monthly"]', saveLabel: true },
      { attr: 'data-tq-price-quarterly', sel: '[data-tq-price-for="quarterly"]', planPrice: true },
      { attr: 'data-tq-strike-quarterly', sel: '[data-tq-strike-for="quarterly"]' },
      { attr: 'data-tq-save-quarterly', sel: '[data-tq-save-for="quarterly"]', saveLabel: true },
      { attr: 'data-tq-buy-once', sel: '[data-tq-buy-once-price]' }
    ];
    map.forEach(function (entry) {
      var value = pill.getAttribute(entry.attr);
      root.querySelectorAll(entry.sel).forEach(function (el) {
        if (entry.saveLabel) {
          var label = (value || '').trim();
          el.textContent = label;
          el.hidden = !label;
          return;
        }
        if (!value) return;
        if (entry.planPrice) {
          el.innerHTML = formatPlanPriceHtml(value);
        } else {
          el.textContent = value;
        }
      });
    });
  }

  function getActiveFlavor(root) {
    return root.querySelector('[data-tq-flavor].is-active');
  }

  function getSelectedPlan(root) {
    var checked = root.querySelector('[data-tq-plan] input[type="radio"]:checked');
    return checked ? checked.value : 'monthly';
  }

  function updateCartUrls(root) {
    var pill = getActiveFlavor(root);
    if (!pill) return;

    var plan = getSelectedPlan(root);
    var planAttr = plan === 'quarterly' ? 'data-tq-url-quarterly' : 'data-tq-url-monthly';
    var cartUrl = pill.getAttribute(planAttr);

    /* Variant + selling plan for the selected flavor and delivery plan. */
    var variantId =
      plan === 'quarterly'
        ? pill.getAttribute('data-tq-variant-quarterly')
        : pill.getAttribute('data-tq-variant-monthly');
    var sellingPlanId =
      plan === 'quarterly'
        ? pill.getAttribute('data-tq-plan-quarterly')
        : pill.getAttribute('data-tq-plan-monthly');

    root.querySelectorAll('[data-tq-add-to-cart]').forEach(function (link) {
      if (cartUrl) link.setAttribute('href', cartUrl);
      if (variantId) link.setAttribute('data-tq-variant-id', variantId);
      if (sellingPlanId) {
        link.setAttribute('data-tq-selling-plan', sellingPlanId);
      } else {
        link.removeAttribute('data-tq-selling-plan');
      }
      /* Optional one-time addon (e.g. Powder Pouch free gift) — subscription ATC only. */
      var addonVariant = pill.getAttribute('data-tq-addon-variant');
      if (addonVariant) {
        link.setAttribute('data-tq-addon-variant', addonVariant);
      } else {
        link.removeAttribute('data-tq-addon-variant');
      }
    });

    var buyOnceUrl = pill.getAttribute('data-tq-buy-once-url');
    var buyOnceVariant = pill.getAttribute('data-tq-buy-once-variant');
    var buyOnceServings = pill.getAttribute('data-tq-buy-once-servings');
    var buyOnceShipping = pill.getAttribute('data-tq-buy-once-shipping');
    var buyOnceLink = root.querySelector('[data-tq-buy-once-link]');
    if (buyOnceLink) {
      if (buyOnceUrl) buyOnceLink.setAttribute('href', buyOnceUrl);
      /* Buy Once is always a one-time purchase — variant only, no selling plan. */
      if (buyOnceVariant) buyOnceLink.setAttribute('data-tq-variant-id', buyOnceVariant);
      buyOnceLink.removeAttribute('data-tq-selling-plan');
      buyOnceLink.removeAttribute('data-tq-addon-variant');
      var servingsEl = buyOnceLink.querySelector('[data-tq-buy-once-servings]');
      if (servingsEl && buyOnceServings) servingsEl.textContent = buyOnceServings;
      var shippingEl = buyOnceLink.querySelector('[data-tq-buy-once-shipping]');
      if (shippingEl && buyOnceShipping) shippingEl.textContent = buyOnceShipping;
    }

    // Keep the mobile sticky bar in sync with the selected plan/flavor.
    var priceAttr = plan === 'quarterly' ? 'data-tq-price-quarterly' : 'data-tq-price-monthly';
    var price = pill.getAttribute(priceAttr);
    var stickyPrice = root.querySelector('[data-tq-sticky-price]');
    if (stickyPrice && price) stickyPrice.textContent = price;
    var stickyLabel = root.querySelector('[data-tq-sticky-label]');
    if (stickyLabel) {
      stickyLabel.textContent =
        plan === 'quarterly' ? 'Three-Month Supply' : 'Monthly Supply';
    }

    /* Hide plan free-shipping note when flavor opts out. */
    var showFreeShip = pill.getAttribute('data-tq-plan-free-shipping') !== 'false';
    root.querySelectorAll('[data-tq-plan-ship]').forEach(function (el) {
      el.hidden = !showFreeShip;
    });

    /* Show storage canister note only for Powder Pouch. */
    var showCanister = pill.getAttribute('data-tq-has-canister') === 'true';
    root.querySelectorAll('[data-tq-plan-canister]').forEach(function (el) {
      el.hidden = !showCanister;
    });
  }

  function selectFlavor(root, pill) {
    var pills = root.querySelectorAll('[data-tq-flavor]');
    pills.forEach(function (p) {
      p.classList.toggle('is-active', p === pill);
    });
    var note = root.querySelector('[data-tq-flavor-note]');
    var text = pill.getAttribute('data-tq-flavor-servings');
    if (note && text) note.textContent = text;
    var gi = pill.getAttribute('data-tq-flavor-gallery');
    if (gi !== null && gi !== '') {
      activateGalleryThumbByIndex(root, gi);
    }
    applyFlavorPricing(root, pill);
    updateCartUrls(root);
  }

  function getUrlVariantId() {
    try {
      return (new URLSearchParams(window.location.search).get('variant') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function flavorMatchesUrlVariant(pill, variantId) {
    var listed = (pill.getAttribute('data-tq-url-variants') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    return listed.indexOf(variantId) !== -1;
  }

  function applyUrlVariant(root) {
    var variantId = getUrlVariantId();
    if (!variantId) return;
    var match = null;
    root.querySelectorAll('[data-tq-flavor]').forEach(function (pill) {
      if (!match && flavorMatchesUrlVariant(pill, variantId)) match = pill;
    });
    if (match) selectFlavor(root, match);
  }

  function initFlavors(root) {
    var pills = root.querySelectorAll('[data-tq-flavor]');
    if (!pills.length) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectFlavor(root, pill);
      });
    });
  }

  function initPlans(root) {
    var labels = root.querySelectorAll('[data-tq-plan]');
    labels.forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', function () {
        labels.forEach(function (l) {
          l.classList.toggle('is-selected', l === label);
        });
        updateCartUrls(root);
      });
    });
  }

  function initSticky(root) {
    var buy = root.querySelector('[data-tq-buybox]');
    var sticky = root.querySelector('[data-tq-sticky]');
    if (!buy || !sticky || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          sticky.hidden = e.isIntersecting;
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.02 }
    );
    io.observe(buy);
  }

  function initNutritionFactsModal(root) {
    var modal = root.querySelector('[data-tq-nf-modal]');
    var openBtns = root.querySelectorAll('[data-tq-nf-open]');
    if (!modal || !openBtns.length) return;

    var closeEls = Array.prototype.slice.call(modal.querySelectorAll('[data-tq-nf-close]'));
    var tabEls = Array.prototype.slice.call(modal.querySelectorAll('[data-tq-nf-tab]'));
    var panelsByKey = {};
    var i;
    for (i = 0; i < tabEls.length; i++) {
      var t = tabEls[i];
      var k = t.getAttribute('data-tq-nf-tab') || '';
      var id = t.getAttribute('aria-controls');
      if (k && id) {
        var p = modal.querySelector('#' + id);
        if (p) panelsByKey[k] = p;
      }
    }

    function tabByKey(key) {
      for (var j = 0; j < tabEls.length; j++) {
        if ((tabEls[j].getAttribute('data-tq-nf-tab') || '') === key) return tabEls[j];
      }
      return null;
    }

    function setActiveTab(key, opts) {
      opts = opts || {};
      var focus = !!opts.focus;
      for (var j = 0; j < tabEls.length; j++) {
        var tab = tabEls[j];
        var tk = tab.getAttribute('data-tq-nf-tab') || '';
        var active = tk === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        var panel = panelsByKey[tk];
        if (panel) panel.hidden = !active;
      }
      if (focus) {
        var ae = tabByKey(key);
        if (ae && typeof ae.focus === 'function') ae.focus();
      }
    }

    function setModalOpen(nextOpen) {
      if (nextOpen) {
        modal.removeAttribute('inert');
        modal.setAttribute('data-open', 'true');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      } else {
        modal.setAttribute('inert', '');
        modal.removeAttribute('data-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    var lastActive = null;

    function openModal() {
      lastActive = document.activeElement;
      setModalOpen(true);
      setActiveTab('juice');
      var x = modal.querySelector('[data-tq-nf-close]:not(.ingm__backdrop)');
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          if (x && typeof x.focus === 'function') x.focus();
        });
      } else if (x && typeof x.focus === 'function') {
        x.focus();
      }
    }

    function closeModal() {
      setModalOpen(false);
      if (lastActive && typeof lastActive.focus === 'function') lastActive.focus();
    }

    for (i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', openModal);
    }
    for (i = 0; i < closeEls.length; i++) {
      closeEls[i].addEventListener('click', closeModal);
    }

    for (i = 0; i < tabEls.length; i++) {
      (function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tq-nf-tab');
          if (key) setActiveTab(key);
        });
        tab.addEventListener('keydown', function (e) {
          var keys = tabEls.map(function (x) {
            return x.getAttribute('data-tq-nf-tab') || '';
          });
          var cur = tab.getAttribute('data-tq-nf-tab') || '';
          var idx = keys.indexOf(cur);
          if (idx < 0) idx = 0;
          if (e.key === 'ArrowRight') idx = (idx + 1) % keys.length;
          else if (e.key === 'ArrowLeft') idx = (idx - 1 + keys.length) % keys.length;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = keys.length - 1;
          else return;
          e.preventDefault();
          setActiveTab(keys[idx], { focus: true });
        });
      })(tabEls[i]);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') closeModal();
    });

    setActiveTab('juice');
  }

  // Continuous auto-scroll for the ingredients carousel (ported from hero.js).
  // Seamless loop by duplicating the cards once and wrapping scrollLeft.
  function initIngredientRail(root) {
    var rail = root.querySelector('[data-ing-rail]');
    if (!rail) return;

    var prevBtn = root.querySelector('[data-ing-prev]');
    var nextBtn = root.querySelector('[data-ing-next]');
    var mobileMq =
      window.matchMedia && window.matchMedia('(max-width: 820px)');
    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var paused = false;
    var baseCount = 0;
    var rafId = 0;
    var lastTs = 0;
    var carry = 0;
    var SPEED = 18; // px per second

    function isMobile() {
      return !!(mobileMq && mobileMq.matches);
    }

    function removeClones() {
      rail.querySelectorAll('.ing__card.is-clone').forEach(function (n) {
        n.remove();
      });
    }

    function setupLoop() {
      removeClones();

      var baseCards = Array.prototype.slice.call(rail.querySelectorAll(':scope > .ing__card:not(.is-clone)'));
      baseCount = baseCards.length;
      if (baseCount < 2) return;

      var frag = document.createDocumentFragment();
      baseCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,input,textarea,select,[tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        frag.appendChild(clone);
      });
      rail.appendChild(frag);
    }

    function getStep() {
      var first = rail.querySelector(':scope > .ing__card');
      if (!first) return 0;
      var railStyle = getComputedStyle(rail);
      var gap = parseFloat(railStyle.columnGap || railStyle.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function wrapIfNeeded() {
      var step = getStep();
      if (!step || baseCount < 2) return;
      var baseWidth = step * baseCount;
      if (rail.scrollLeft >= baseWidth) rail.scrollLeft -= baseWidth;
      if (rail.scrollLeft < 0) rail.scrollLeft += baseWidth;
    }

    function stop() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      lastTs = 0;
      carry = 0;
    }

    function tick(ts) {
      if (!rafId) return;
      if (!lastTs) lastTs = ts;

      var dt = Math.min(0.05, (ts - lastTs) / 1000);
      lastTs = ts;

      if (!paused) {
        carry += SPEED * dt;
        var delta = Math.floor(carry);
        if (delta > 0) {
          carry -= delta;
          rail.scrollLeft += delta;
          wrapIfNeeded();
        }
      }

      rafId = requestAnimationFrame(tick);
    }

    function stepBy(dir) {
      var step = getStep();
      if (!step) return;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function start() {
      stop();
      removeClones();

      rail.style.overflowX = 'auto';

      /* Mobile: one card at a time, manual arrows only — no auto-scroll. */
      if (isMobile() || prefersReduced) {
        rail.style.scrollBehavior = 'smooth';
        rail.style.scrollSnapType = 'x mandatory';
        return;
      }

      rail.style.scrollBehavior = 'auto';
      rail.style.scrollSnapType = 'none';

      setupLoop();

      if (baseCount < 2) return;
      if (rail.scrollWidth <= rail.clientWidth + 2) return;

      rafId = requestAnimationFrame(tick);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stepBy(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stepBy(1);
      });
    }

    rail.addEventListener('pointerenter', function () {
      paused = true;
    });
    rail.addEventListener('pointerleave', function () {
      paused = false;
    });
    rail.addEventListener('focusin', function () {
      paused = true;
    });
    rail.addEventListener('focusout', function () {
      paused = false;
    });
    rail.addEventListener('pointerdown', function () {
      paused = true;
    });
    rail.addEventListener('pointerup', function () {
      paused = false;
    });

    var userPauseT = 0;
    function pauseFor(ms) {
      paused = true;
      window.clearTimeout(userPauseT);
      userPauseT = window.setTimeout(function () {
        wrapIfNeeded();
        paused = false;
      }, ms);
    }

    rail.addEventListener('wheel', function () {
      pauseFor(900);
    }, { passive: true });
    rail.addEventListener('touchstart', function () {
      paused = true;
    }, { passive: true });
    rail.addEventListener('touchmove', function () {
      pauseFor(900);
    }, { passive: true });
    rail.addEventListener('touchend', function () {
      paused = false;
    }, { passive: true });

    if (mobileMq && typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', start);
    } else if (mobileMq && typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(start);
    }
    window.addEventListener('resize', start);

    start();
  }

  function initReviewsCarousel(root) {
    var rail = root.querySelector('[data-tq-rev-rail]');
    var prev = root.querySelector('[data-tq-rev-prev]');
    var next = root.querySelector('[data-tq-rev-next]');
    if (!rail || !prev || !next) return;

    function stepWidth() {
      var first = rail.querySelector('.tq-review-card');
      if (!first) return 0;
      var style = getComputedStyle(rail);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: stepWidth(), behavior: 'smooth' });
    });
  }

  function initHsaModal(root) {
    var modal = root.querySelector('[data-tq-hsa-modal]');
    var openBtns = root.querySelectorAll('[data-tq-hsa-open]');
    if (!modal || !openBtns.length) return;

    var closeEls = Array.prototype.slice.call(modal.querySelectorAll('[data-tq-hsa-close]'));
    var lastActive = null;

    function setOpen(open) {
      if (open) {
        modal.removeAttribute('inert');
        modal.setAttribute('data-open', 'true');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      } else {
        modal.setAttribute('inert', '');
        modal.removeAttribute('data-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    function openModal() {
      lastActive = document.activeElement;
      setOpen(true);
      var x = modal.querySelector('.ingm__x');
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          if (x && typeof x.focus === 'function') x.focus();
        });
      } else if (x && typeof x.focus === 'function') {
        x.focus();
      }
    }

    function closeModal() {
      setOpen(false);
      if (lastActive && typeof lastActive.focus === 'function') lastActive.focus();
    }

    Array.prototype.forEach.call(openBtns, function (btn) {
      btn.addEventListener('click', openModal);
    });
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') closeModal();
    });
  }

  function initStoryExpand(root) {
    var btn = root.querySelector('[data-tq-story-expand]');
    var full = root.querySelector('[data-tq-story-full]');
    var short = root.querySelector('.tq-story-short');
    if (!btn || !full) return;
    btn.addEventListener('click', function () {
      full.classList.add('is-open');
      if (short) short.classList.add('is-expanded');
      btn.hidden = true;
    });
  }

  function initCmpMobileExpand(root) {
    var more = root.querySelector('.tq-cmp-mobile__more');
    var desktop = root.querySelector('[data-tq-cmp-desktop]');
    if (!more || !desktop) return;
    more.addEventListener('toggle', function () {
      desktop.classList.toggle('is-forced-open', more.open);
    });
  }

  function onReady() {
    var root = document.querySelector('[data-tq-page]');
    if (!root) return;
    initGallery(root);
    initFlavors(root);
    applyUrlVariant(root);
    initPlans(root);
    initSticky(root);
    initNutritionFactsModal(root);
    initHsaModal(root);
    initIngredientRail(root);
    initReviewsCarousel(root);
    initStoryExpand(root);
    initCmpMobileExpand(root);
    var activeFlavor = getActiveFlavor(root);
    if (activeFlavor) applyFlavorPricing(root, activeFlavor);
    updateCartUrls(root);
    /* Re-wire ATC buttons after flavor URL attributes are applied (global cart drawer). */
    if (window.TQCart && typeof window.TQCart.wireAddButtons === 'function') {
      window.TQCart.wireAddButtons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
